@if (this.config.data?.dialogType == 'input-field') {
    <div class="w-full padding-py-4 p-input-icon-right">
        <input
            class="w-full my-2"
            pInputText
            [(ngModel)]="skillData.skillName"
            placeholder="{{ 'default-cm-skills' | translate: 'Skill' }}"
        />
        <i p-input-icon-right class="bg-white">{{ skillName?.length }}/255</i>
        <p-rating [(ngModel)]="skillData.rating" [cancel]="false" class="w-full ml-2" />
        @if ((skillName?.length || 0) > 255) {
            <span class="text-red-500 text-sm"
                >{{
                    'default-character-exceed'
                        | translate
                            : 'Cannot exceed
        255
        characters'
                }}
            </span>
        }
    </div>
    <div class="flex w-full gap-3 padding-py-16">
        <p-button
            class="w-full"
            [outlined]="true"
            (click)="cancel($event)"
            label="{{ 'default-cm-no' | translate: 'No' }}"
            styleClass=" text-sm w-full"
        ></p-button>
        <p-button
            class="w-full"
            (click)="addNewSkill()"
            label="{{ 'default-cm-yes' | translate: 'Yes' }}"
            styleClass="text-sm w-full"
        ></p-button>
    </div>
} @else if (config.data?.dialogType == 'confirm') {
    <div class="flex flex-column align-items-center justify-content-between h-full w-full">
        <div class="w-full text-gray-300 font-normal">
            @if (config.data?.message) {
                <p>
                    {{
                        config.data.message
                            | translate
                                : 'Warning: Removing yourself from the admin group will result in immediate logout and loss of
            administrative privileges. Do you wish to proceed?'
                    }}
                </p>
            } @else {
                <p>
                    {{ 'default-cm-deleteConfirmationMessage' | translate: 'Are you sure you want to delete this ?' }}
                </p>
            }
        </div>
        <div class="flex w-full gap-3">
            <div class="flex-1">
                <p-button
                    label="{{ 'default-cm-no' | translate: 'No' }}"
                    (onClick)="cancel($event)"
                    [outlined]="true"
                    styleClass="w-full"
                ></p-button>
            </div>
            <div class="flex-1">
                <p-button
                    label="{{ 'default-cm-yes' | translate: 'Yes' }}"
                    (onClick)="submitForm($event)"
                    styleClass="w-full"
                ></p-button>
            </div>
        </div>
    </div>
}
